import type { ReactNode } from "react";
import "./cashier-presentation-v2-surfaces.css";

type Language = "ar" | "en";

type CashierCartV2Props = {
  language: Language;
  header?: ReactNode;
  lines: ReactNode;
  summary?: ReactNode;
  checkout?: ReactNode;
  actions?: ReactNode;
  empty?: boolean;
  onNewOrder?: () => void;
};

/**
 * Clean cart composition. Geometry is fixed by structure, not by positioning.
 * Header -> Lines(scroll) -> Summary -> Checkout -> Actions.
 */
export function CashierCartV2({
  language,
  header,
  lines,
  summary,
  checkout,
  actions,
  empty = false,
  onNewOrder
}: CashierCartV2Props) {
  const ar = language === "ar";

  return (
    <section className="cashier-v2-cart" aria-label={ar ? "سلة الطلب" : "Order cart"}>
      <header className="cashier-v2-cart__header">
        {header ?? <strong>{ar ? "سلة الطلب" : "Order cart"}</strong>}
      </header>

      <div className="cashier-cart-lines cashier-v2-cart__lines">
        {empty ? (
          <div className="cashier-v2-cart__empty">
            <span aria-hidden="true">▤</span>
            <strong>{ar ? "لا يوجد طلب نشط" : "No active order"}</strong>
            <p>{ar ? "ابدأ طلبًا جديدًا لإضافة المنتجات." : "Start a new order before adding products."}</p>
            {onNewOrder ? (
              <button type="button" data-testid="empty-cart-new-order" onClick={onNewOrder}>
                {ar ? "طلب جديد" : "New Order"}
              </button>
            ) : null}
          </div>
        ) : lines}
      </div>

      {summary ? <div className="cashier-v2-cart__summary">{summary}</div> : null}
      {checkout ? <div className="cashier-v2-cart__checkout">{checkout}</div> : null}
      {actions ? <div className="cashier-action-bar cashier-v2-cart__actions">{actions}</div> : null}
    </section>
  );
}
